import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GatepassTypeCardStyled = styled(Card)(() => ({
  "& .MuiSvgIcon-root": {
    fontSize: 56,
  },
  "& img": {
    width: 56,
    height: 56,
  },
}));
